export default {
  type: "object",
  properties: {
    type: {
      type: "integer",
      description: "Id of object 'fit'",
      example: 1
    },
    measure: {
      type: "integer",
      description: "id of object 'measure'",
      example: "bodyHeight"
    }
  }
};
